// 1228 Safety Card 인센티브 Cap 공용 로직
// - Cap 설정은 1231 저장게시판(연도별 1건, body.capList[{사업장명, 점수}])에 보관
// - "현재 발부" 점수는 결재완료(승인, statusIds [4]) 건 중 발급일자가 해당 연도인 문서의 등급 점수 합산
//   (1227 현황 집계·validateCap 과 동일 기준)

export const CAP_BOARD_ID = 1231;
export const SAFETY_CARD_BOARD_ID = 1228;
export const GRADE_SCORE = { 개선: 1, 우수: 2, 탁월: 3 };

/**
 * 연도별 Cap 설정 조회
 * @returns {{ post: object|null, capList: Array<{사업장명: string, 점수: any}> }}
 */
export async function loadCapSetting(store, projectId, year) {
  const response = await store.dispatch("board/LOAD_POST_LIST", {
    projectId: parseInt(projectId),
    boardId: CAP_BOARD_ID,
    page: 1,
    perPage: 1,
    conditions: [{ key: "body.연도", operator: "=", value: `${year}` }],
    // LOAD_POST_LIST 5초 메모리 캐시 우회용 (저장 직후 재조회 대비)
    cacheBuster: Date.now(),
  });
  const post = response.data && response.data.length > 0 ? response.data[0] : null;
  let capList = [];
  if (post) {
    try {
      capList = (JSON.parse(post.post_content).body || {}).capList || [];
    } catch (e) {
      capList = [];
    }
  }
  return { post, capList };
}

/** capList 에서 사업장 Cap 점수를 꺼낸다. 미설정이면 null */
export function findCap(capList, fieldName) {
  const row = (capList || []).find((item) => item.사업장명 === fieldName);
  if (!row) return null;
  const cap = parseInt(row.점수);
  return isNaN(cap) ? null : cap;
}

/**
 * 해당 연도의 사업장별 발부(승인완료) 누적 점수
 * @param {object} options
 * @param {string} [options.fieldName] 특정 사업장만 조회 (없으면 전체 사업장)
 * @param {number} [options.excludePostId] 누적에서 제외할 문서 id (작성 중인 현재 문서)
 * @param {number} [options.boardId] 기본 1228
 * @returns {Object<string, number>} { 사업장명: 누적점수 }
 */
export async function loadIssuedScoreByField(store, projectId, year, options = {}) {
  const boardId = options.boardId || SAFETY_CARD_BOARD_ID;
  const conditions = [{ key: "body.발급일자", operator: "LIKE", value: `${year}-%` }];
  if (options.fieldName) {
    conditions.push({ key: "body.stdInfo.field_name", operator: "=", value: options.fieldName });
  }
  const baseOptions = {
    projectId: parseInt(projectId),
    boardSlug: `board-${boardId}`,
    perPage: 200,
    statusIds: [4], // 1:temp 2:registered 3:ongoing 4:approved 5:rejected
    conditions,
    withMeta: true,
    onlyMeta: true,
    metaKeys: ["body.stdInfo.field_name", "body.등급"],
  };
  const excludePostId = parseInt(options.excludePostId) || 0;

  const result = {};
  let page = 1;
  for (;;) {
    const response = await store.dispatch("approval/LOAD_POST_ALL", { ...baseOptions, page, cacheBuster: Date.now() });
    for (const item of response.data || []) {
      const postId = item.post ? parseInt(item.post.id) : 0;
      if (excludePostId && postId === excludePostId) continue;
      const body = (item.postContents || {}).body || {};
      const fieldName = (body.stdInfo && body.stdInfo.field_name) || options.fieldName || "";
      result[fieldName] = (result[fieldName] || 0) + (GRADE_SCORE[body.등급] || 0);
    }
    if (page >= (response.last_page || 1)) break;
    page++;
  }
  return result;
}
